import { AccountModel } from "./account.model";
import { PeriodModel } from "./period.model";
import { AdjustmentAccountPeriodModel } from "./adjustmentAccountPeriod.model";
import { EntityModel } from "./legalentity-model";


export class AdjustmentModel {
  id: number;
  engagementId: number;
  engagementName?: string;
  entityId: EntityModel[];
  mappingId: number;
  mapping?: string;
  adjustmentCategoryId: number;
  adjustmentCategory?: string;
  adjustmentTypeId: number;
  adjustmentType?: string;
  modifiedDate?: Date;
  modifiedById: number;
  AccData?: AccountModel[];
  accountName?: string;
  adjustmentName: string;
  periods:PeriodModel[];
  periodName?:string;
  adjustmentAccountPeriods?: AdjustmentAccountPeriodModel[];
  isSelected? : boolean;
  entityId2?: EntityModel[];  
}
